import { Box } from '@material-ui/core';
import { UserType } from '@nemuru-eng/js-api-client';

import { useCheckoutSessionContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/contexts/CheckoutSessionContext';
import { PaymentIntentCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/PaymentIntentList/components/PaymentIntentCard';
import { PaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/PaymentMethodDetail/PaymentMethodDetailEntity';
import { CustomPaper } from '@/components/shared/components/CustomPaper';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { FlexRow } from '@/components/shared/components/FlexRow';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

interface PaymentIntentListProps<T extends PaymentMethodDetailEntity> {
  paymentMethodDetailEntity: T;
}

const PaymentIntentListComponent = <T extends PaymentMethodDetailEntity>({
  paymentMethodDetailEntity,
}: PaymentIntentListProps<T>) => {
  const { checkoutSessionEntity } = useCheckoutSessionContext();

  const paymentIntents = paymentMethodDetailEntity.getPaymentIntents();

  if (!checkoutSessionEntity) {
    return null;
  }

  if (paymentIntents.length <= 1) {
    return null;
  }

  // const otherPaymentIntents = paymentIntents; //.slice(1);

  return (
    <CustomPaper fill="paper">
      <FlexRow>
        <Font variant="subtitle1" color="title">
          <Text strong tId={'PAYMENT_INTENTS_LIST_TITLE'} />
        </Font>
      </FlexRow>
      <Box mt={2} />
      <FlexColumn gridGap={16}>
        {paymentIntents.map((pi) => {
          const isSelected = paymentMethodDetailEntity.paymentIntentId === pi.id;
          return (
            <PaymentIntentCard
              key={pi.id}
              isSelected={isSelected}
              paymentIntent={pi}
              checkoutSessionEntity={checkoutSessionEntity}
            />
          );
        })}
      </FlexColumn>
    </CustomPaper>
  );
};

const PaymentIntentListModule = withPermissionsModule(PaymentIntentListComponent);

export const PaymentIntentList = (props: PaymentIntentListProps<PaymentMethodDetailEntity>) => {
  return (
    <PaymentIntentListModule
      {...props}
      permissions={{
        view: [UserType.ADMIN, UserType.SUPER_ADMIN],
      }}
    />
  );
};
